import { X } from 'lucide-react'

import { CustomerVisitHistoryPanel } from '@/components/masters/CustomerVisitHistoryPanel'
import { Button } from '@/components/ui/button'
import { formatE164Display } from '@/lib/phone'

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {number | null} props.customerId
 * @param {string} [props.customerName]
 * @param {string | null} [props.customerPhone]
 */
export function PosCustomerHistoryModal({
  open,
  onClose,
  customerId,
  customerName = '',
  customerPhone = null,
}) {
  if (!open) return null

  return (
    <div className="pos-v2-modal-backdrop" role="presentation">
      <div
        className="pos-v2-modal max-h-[85vh] w-full max-w-lg flex flex-col"
        role="dialog"
        aria-label="Customer visit history"
      >
        <div className="flex shrink-0 items-center justify-between border-b border-[#E5E7EB] px-4 py-3">
          <div>
            <h2 className="text-sm font-bold text-slate-900">
              {customerName || 'Visit history'}
            </h2>
            {customerPhone ? (
              <p className="text-[11px] text-slate-500">{formatE164Display(customerPhone)}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-slate-500 hover:bg-slate-100"
            aria-label="Close"
          >
            <X className="h-4 w-4" aria-hidden />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto p-4">
          <CustomerVisitHistoryPanel
            customerId={customerId}
            variant="pos"
            visitLimit={25}
          />
        </div>

        <div className="shrink-0 border-t border-[#E5E7EB] p-4">
          <Button type="button" className="min-h-[44px] w-full" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}
